

var isOnline = location.host.indexOf('chmemm.com') != -1;
// var baseUrl = isOnline ? '//api.chmemm.com/index.php?r=' : '//api.chmemm.com/index.php?r='
var baseUrl = isOnline ? '//api.chmemm.com/index.php?r=' : '//api.chmemm.com/index.php?r='

export default {
    apiHost: baseUrl
}



// WEBPACK FOOTER //
// ./src/config.js